import { takeEvery, put } from "redux-saga/effects";
import { request } from "../../../api/Service";
import { getErrorMessage } from "../../../components/utils/errorHandler";
import { toast } from "react-toastify";
export default function* watcherAddLogisticsSaga() {
  yield takeEvery("ADD_LOGISTICS_COSTER", workerSaga);
}

function* workerSaga(action) {
  try {
    yield put({ type: "DISPLAY_LOADER" });
    let payload = {};
    yield request("post", action.payload, "/add-logistics-cost").then(
      (response) => {
        payload = response;
      }
    );

    toast.success(payload);
    var formatUrl = "/get-logistics-costs";
    yield request("get", action.payload, formatUrl).then((response) => {
      payload = response;
    });
    yield put({ type: "LOGISTICS_COST_LIST", payload: payload });

    yield put({ type: "DISPLAY_LOADER" });
  } catch (e) {
    yield put({ type: "LOADING_BUTTON_SPINNER" });
    console.log("add-logistics-cost-saga", e);
    yield put({ type: "DISPLAY_LOADER" });
    console.log("add-logistics-cost-saga", e.response);
    const errorMessage = getErrorMessage(e.response);
    toast.error(errorMessage);
    yield put({ type: "API_ERRORED", payload: e });
  }
}
